<template>
  <header
    class="
      _header
      pt-8      
      px-0
      text-center
      bg-gradient-to-b
      from-gradient-start
      capitalize
      text-dark
    "
  >
    <h1 class="text-3xl font-bold">Moroccan Truckers</h1>
    <p class="my-5 text-lg">
      collect Moroccan truckers around the world in one load
      <br />any question you can
      <a class="underline" href="mailto:mouhcinedev@gmail.com">contact me</a>
    </p>
  </header>

  <ChartComp />

  <section class="_container">
    <Card v-if="randomCards.length >= 1" :randomCards="randomCards" />
    <div v-else>loading...</div>
  </section>
  <Footer />
</template>

<script>
import Card from "./components/Card.vue";
import Footer from "./components/Footer.vue";
import ChartComp from "./components/ChartComp.vue";

export default {
  name: "App",
  data() {
    return {
      truckers: [],
      virtaulArray: [],
      randomCards: [],
    };
  },
  components: {
    ChartComp,
    Card,
    Footer,
  },
  methods: {
    randomizArray(data) {
      let numOfCards = this.virtaulArray.length;
      let arrayLength = this.virtaulArray.length;
 
      for (let i = 0; i < arrayLength; i++) {
        let num = Math.floor(Math.random() * numOfCards);
        
        this.randomCards.push(data[num]); //push it to the array then splice it
        data.splice(num, 1); // remove the card
        numOfCards--;  // -1 from the array
      } 
    },
    fetchData: async function () {
      const data = await fetch("./data.json");
      const res = await data.json();
      this.virtaulArray = res.truckers;

      this.randomizArray(this.virtaulArray);
    },
  },

  mounted() {
    this.fetchData();
  },
  updated() {
    const channel = document.querySelectorAll("._container .channel");

    let options = {
      threshold: 0.3,
    };
    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((item) => {
        if (!item.isIntersecting) {
          return;
        } else {
          item.target.classList.add("appear");
          observer.unobserve(item.target);
        }
      });
    }, options);

    channel.forEach((item) => {
      observer.observe(item);
    });
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
:root {
  --dark: #101020;
  --light: #fff;
  --h2-hover: #ddd;
  --dark-hover: #4545ad;
  --green: rgb(105, 255, 180);
}

.dark {
  --dark: #fff;
  --light: #101020;
  --h2-hover: #ddd;
  --dark-hover: #4545ad;
}

html,
body {
  color: var(--dark);
}

body {
  background-color: var(--light);
}

._container {
  max-width: 1200px;
  display: grid;
  grid-template-columns: repeat(3, minmax(100px, 1fr));
  gap: 1rem;
  margin: auto;
  justify-items: center;
  padding: 0 1rem;
  min-height: 50vh;
}

/* Medium devices */

@media only screen and (max-width: 768px) {
  ._container {
    grid-template-columns: repeat(2, minmax(100px, 1fr));
  }
}

/* Extra small devices */

@media only screen and (max-width: 600px) {
  ._container {
    grid-template-columns: repeat(1, minmax(100px, 1fr));
  }
}
</style>